import React from 'react';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from "../../common/noDataComponent";
import AddressRow from '../identData/addressRow';
import BasicRow from '../identData/basicRow';
import HistoryRow from '../identData/historyRow';

class ESGIdentData extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        return (
            <div className="ident-data">
                <HistoryRow name={data.companyName} />
                <BasicRow title="Report.CompanyIdentification.Ico" value={data.companyId} />
                <AddressRow address={data.address} />
                <BasicRow title="Report.CompanyIdentification.DateOfRegistration" value={data.creationDateFormated} />
                <BasicRow title="Report.CompanyIdentification.PrimaryNace" value={data.nace} />
                <BasicRow title="Report.ESG.IdentData.EconomicSector" value={data.sectorName} />
            </div>
        )
    }

}

export default connect(state => state.report)(ESGIdentData);